import { Constructor } from '@skylab-shared/types';

export class JoinPointContext {
    private internalCanceled: boolean = false;

    public constructor(public readonly sender: any) { }

    public get canceled(): boolean {
        return this.internalCanceled;
    }

    public cancel(): void {
        this.internalCanceled = true;
    }
}

export class JoinPoint<TContext extends JoinPointContext> {
    public constructor(public readonly context: TContext) { }
}

export type JoinPointConstructor<TJoinPointContext extends JoinPointContext = JoinPointContext> = Constructor<JoinPoint<TJoinPointContext>>;
